export default "__VITE_ASSET__$w2gUZN0__"